module.exports = __webpack_public_path__ + "cf2fea9c162477eac6e4ef668cc5597b.jpg";